var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEditChatName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6864 2.19621C11.3074 1.5234 11.6179 1.187 11.9478 0.990772C12.744 0.517299 13.7242 0.502576 14.5336 0.951935C14.8691 1.13817 15.1891 1.4651 15.8292 2.11897C16.4693 2.77284 16.7893 3.09977 16.9716 3.44244C17.4115 4.26927 17.3971 5.27066 16.9336 6.08392C16.7415 6.42097 16.4122 6.73815 15.7536 7.37251L7.91719 14.9202C6.66906 16.1224 6.045 16.7235 5.26505 17.0281C4.4851 17.3328 3.62767 17.3103 1.9128 17.2655L1.67948 17.2594C1.15742 17.2457 0.896391 17.2389 0.744655 17.0667C0.592919 16.8945 0.613635 16.6286 0.655066 16.0968L0.677563 15.808C0.794174 14.3113 0.852479 13.5629 1.14476 12.8902C1.43703 12.2175 1.9412 11.6712 2.94952 10.5788L10.6864 2.19621Z",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79199 2.29102L15.6253 8.12435",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 17.291L17.2917 17.291",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditChatName);
export default __webpack_public_path__ + "static/media/icon-edit-chat-name.7daa96dea81e012deba4775ff0aa9292.svg";
export { ForwardRef as ReactComponent };